export default {
  ubicaciones: [],
  ubicacionesActivas: [],
  selectedUbicacion: null,
  error: false,
  errorMessage: [],
}
